import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Uppy from '@uppy/core';
import FileInput from '@uppy/file-input';
import XHRUpload from '@uppy/xhr-upload';
import ProgressBar from '@uppy/progress-bar';
import { errorMessage } from '../../../utils/errors';
import Label from '../../atoms/label/label';
import { getRootEntryPoint, getAuth } from '../../../store/externalCalls/httpCalls';
import './formUploadSync.scss';

const FormUploadSync = (props) => {
  const { endpoint, helpText, onSuccess, fileExtensionType } = props;

  useEffect(() => {
    const uppy = new Uppy({
      debug: true,
      autoProceed: true,
      allowMultipleUploads: false,
      restrictions: {
        maxFileSize: 104857600,
        minNumberOfFiles: 1,
        allowedFileTypes: fileExtensionType,
      },
      locale: {
        strings: {
          chooseFiles: 'Select file',
        },
      },
    });
    uppy.use(FileInput, {
      target: '.UppyForm',
      replaceTargetContent: true,
    });
    uppy.use(ProgressBar, {
      target: '.UppyProgressBar',
      hideAfterFinish: false,
    });
    uppy.use(XHRUpload, {
      endpoint: getRootEntryPoint() + endpoint,
      formData: true,
      fieldName: 'file',
      headers: getAuth(),
    });
    uppy.on('upload-error', (file, error, response) => {
      console.log(response);
      const message = response.body.message;
      errorMessage(message);
      uppy.reset();
    });
    uppy.on('upload-success', (file, response) => {
      onSuccess(file, response);
      uppy.reset();
    });
    uppy.on('error', (file, response) => {
      console.log(file, response);
      uppy.reset();
    });
  }, [endpoint]);
  
  return (
    <div>
      <div className="form-group row">
        <Label helpText={helpText}>Load new values from file</Label>
        <form action="" className="UppyForm formUploadSync col-sm-8">
          <input type="file" name="file" />
        </form>
      </div>
      <div className="UppyProgressBar" />
    </div>
  );
};

FormUploadSync.propTypes = {
  endpoint: PropTypes.string.isRequired,
  helpText: PropTypes.string,
  onSuccess: PropTypes.func,
};

FormUploadSync.defaultProps = {
  helpText: '',
  onSuccess: () => {},
};


export default FormUploadSync;
